module.exports = __webpack_public_path__ + "media/images/front/materiales_inf-b3f792a242bbfdc82ef8ff85baf911b2.webp";